import { PermissionRoute, type PermissionRouteData } from '@exam-management/permission-route';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';

export default function NewQuestionCreationTaskDetailsRouteController() {
  const { taskId } = useParams('/task-management/question-creation/:taskId');

  const defaultRoutes: PermissionRouteData[] = [
    {
      path: '/task-management/question-creation/:taskId/details',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
    {
      path: '/task-management/question-creation/:taskId/question-list',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
      params: {
        taskId,
      },
    },
  ];

  return <PermissionRoute routes={defaultRoutes} />;
}
